<template>
  <NuxtLink
    :to="data.url"
    class="gradient-transition-effect group relative z-10 block bg-gradient-to-tr from-blue-50 to-blue-10/40 px-4 py-6 after:bg-gradient-to-tr after:from-blue-100/50 after:to-blue-50/50 sm:py-8 sm:pl-8 sm:pr-10"
  >
    <div class="flex justify-between">
      <h2 class="text-2xl font-medium sm:text-3xl">
        <span v-html="$replaceHtmlTags(data.heading)" />
        <span v-if="data.workload"> ({{ data.workload }})</span>
      </h2>
      <div class="flex gap-4 lg:gap-8">
        <p class="hidden whitespace-nowrap text-blue-dark-700/50 md:block">
          {{ $t('advertisement_dated') }} {{ createdAt }}
        </p>
      </div>
    </div>

    <p class="mb-1 text-base font-medium text-blue-800 sm:text-md">
      {{ data.company_title }}
    </p>

    <div class="mt-4 flex items-end justify-between sm:mt-5 nav:items-center">
      <JobMetaTiles
        is-job-card
        is-white
        :page="data"
        class="flex flex-wrap gap-3"
      />
      <!-- DESKTOP -->
      <ArrowGrowIcon class="-mr-2 hidden h-4 text-blue-800 sm:block" />
    </div>
    <!-- MOBILE -->
    <div class="mt-8 flex items-center justify-between md:hidden">
      <p class="whitespace-nowrap text-sm text-blue-dark-700/50">
        {{ $t('advertisement_dated') }} {{ createdAt }}
      </p>

      <ArrowIcon class="w-4 shrink-0 text-blue-800" />
    </div>
  </NuxtLink>
</template>

<script setup>
const { locale } = useI18n()
const props = defineProps({
  data: { type: Object, required: true },
})

const createdAt = computed(() => {
  if (!props.data?.created_at) {
    return null
  }

  return new Date(props.data.created_at).toLocaleDateString(locale.value, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
})
</script>
